import { UsageInputLabelComponentType } from './types'
import styles from './UsageInputLabelComponent.module.scss'
import { Button, Icon, Tooltip } from '@boltenergy-be/design-system'
import parse from 'html-react-parser'

const UsageInputLabelComponent = ({ label, onClick, tooltip }: UsageInputLabelComponentType) => {
  return (
    <div className={styles['label-component-slot']}>
      <Button onClick={onClick} representation="link" size="small" type="button">
        {label}
      </Button>
      {tooltip && (
        <Tooltip tooltipContent={parse(tooltip)}>
          <Icon name="questionMarkCircle" />
        </Tooltip>
      )}
    </div>
  )
}

export default UsageInputLabelComponent
